import { Form } from 'antd';
import React, { FC, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';

const CsvReport: FC<{
  onChange: (item: any) => void;
}> = ({ onChange }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const inputRef = useRef();
  useEffect(() => {
    ChangeValue();
  }, [inputRef]); // eslint-disable-line react-hooks/exhaustive-deps

  const ChangeValue = async () => {
    try {
      await form.validateFields();
    } catch {
      return;
    }

    onChange(form.getFieldValue('csvSeparator'));
  };

  return (
    <Form form={form} layout="vertical" autoComplete="off">
      <Form.Item initialValue={','} name={'csvSeparator'} label={t('Separator')}>
        <Select style={{ width: '100%' }} onChange={ChangeValue}>
          <Select.Option value={','}>{t('Comma')}</Select.Option>
          <Select.Option value={';'}>{t('Semicolon')}</Select.Option>
          <Select.Option value={'\t'}>{t('Tab')}</Select.Option>
        </Select>
      </Form.Item>
    </Form>
  );
};

export default CsvReport;
